module.exports = __webpack_public_path__ + "static/zhongli-button-3ddce197e497c0d03d04b260a353e92c.png";